<template>
  <div class="pb-9">
<!--    <div class="text-center mt-16 mb-16" dir="auto">-->
<!--      <div v-scroll-reveal.reset class="text-right w-80 mx-auto mt-16 mb-16" dir="auto">-->
<!--        <h2  class="bloc-header font-weight-bold" >ماشین حساب</h2>-->
<!--      </div>-->

<!--    </div>-->
    <v-container>
      <section style="min-height: 300px" class="question-box d-block">
        <h5 class="font-weight-bold text-center question-category-title">{{ $t('Calculator') }}</h5>
        <v-row>
          <v-col class="px-16" cols="12">
            <v-text-field
                label="مقدار مورد نظر را وارد کنید"
                hint="از وارد کردن حروف خودداری کنید"
                type="number"
                class="mx-16"
                v-model="inputValue"
                height="50"
                flat
                dense
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xl="6" lg="6">

            <v-select
            v-model="selectedUnit"
            label="واحد مورد نظر را انتخاب کنید"
            placeholder="واحد را وارد کنید"
                height="50"
                dense
                outlined
            :items="unit"
            ></v-select>
          </v-col>
          <v-col cols="12" xl="6" lg="6">
            <v-select
                v-model="selectedThickness"
                label="ضخامت مورد نظر را انتخاب کنید"
                placeholder="ضخامت را وارد کنید"
                height="50"
                dense
                outlined
                :items="blockThickness"
            ></v-select>
          </v-col>
        </v-row>
<div class="result-box">
  <v-container>
<v-row>
  <v-col cols="6"></v-col>
</v-row>
  </v-container>
</div>
      <v-btn  :disabled="details.length<2" block large depressed  color="warning">
        <h5 class="font-weight-bold primary--text">محاسبه</h5>
        <h5 class="font-weight-bold primary--text">{{details}}</h5>
      </v-btn>
      </section>

    </v-container>
  </div>
</template>
<script>
export default {
  name: 'lightBlockCalculator',
  data(){
    return{
      inputValue:Number,
      selectedUnit:'',
      selectedThickness:'',
      result:null,
      unit:['متر مربع','متر مکعب','پالت','تریلی'],
      blockThickness:[8,10,12,15,20,30],
      details:[]
    }
  },
  methods:{
    myDetails(e){
      this.details.push(e);

    }
  }

}
</script>
<style scoped>
.result-box{
  border: 1px solid #9e9e9e;
  min-height: 200px;
  width: 79%;
  border-radius: 9px;
  margin: auto auto 20px;
}
</style>